<template>
  <StackLayout class="wrapper">
    <AgCard :avatar="!!icon" modal :caption="caption">
      <AgAvatar v-if="!!icon" frameless slot="avatar">
        <AgIcon :type="icon" size="90" />
      </AgAvatar>
      <StackLayout class="card-content">
        <AgHtml :src="text" autoHeight />
        <AgButton outlined text="Schließen" @tap="close" @click="close" />
      </StackLayout>
    </AgCard>
  </StackLayout>
</template>

<script>

export default {
  props: {
    caption: String,
    text: String,
    icon: String
  },
  methods: {
    close () {
      this.$emit('done')
    }
  }
}

</script>